module.exports = __webpack_public_path__ + "h5/img/logo_white.08e38f75.png";